import { classNames, Touch } from '@vkontakte/vkui';
import { useAudioWaveform } from './useAudioWaveform';
import { UseAudioWaveformParams } from './types';
import styles from './AudioWaveform.module.css';

interface AudioWaveformProps extends UseAudioWaveformParams {}

export function AudioWaveform(props: AudioWaveformProps) {
  const {
    className,
    isInteractDisabled,
    color,
    waveform,
    getProgressSetterRef,
    onProgressMoveStart,
    onProgressMove,
    onProgressMoveEnd,
    lineGap,
    lineWidth,
    waveformMaxValue,
    ...touchProps
  } = props;
  const { endXHandler, moveXHandler, startXHandler, onClick, canvasRef } = useAudioWaveform({
    color,
    isInteractDisabled,
    waveform,
    getProgressSetterRef,
    onProgressMoveStart,
    onProgressMove,
    onProgressMoveEnd,
    lineGap,
    lineWidth,
    waveformMaxValue,
  });

  return (
    <Touch
      style={
        {
          '--wave-color': color,
        } as React.CSSProperties
      }
      Component="canvas"
      onClick={onClick}
      onStartX={startXHandler}
      onMoveX={moveXHandler}
      onEndX={endXHandler}
      className={classNames(styles.root, className)}
      getRootRef={canvasRef}
      aria-valuemin={0}
      aria-valuemax={1}
      data-testid="audio-waveform"
      {...(isInteractDisabled ? {} : { role: 'slider' })}
      {...touchProps}
    />
  );
}
